import AntIcon from "@/components/icons/AntIcon";
import { Button, Flex, Form, FormInstance } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { rowGutter } from "../../../../common/constants";
import { AgentCommonFilterFields } from "../../../agent/components/commonfilters/AgentCommonFilterFields";
import { AgentExtendedFilterModalForm } from "../../../agent/components/commonfilters/AgentExtendedFilterModalForm";
import { SloveniaCompetitionResultFilterPageRequest } from "../../types";

type ExtendedFilter = { completedEducationDateRange?: string[]; completedAcademyDateRange?: string[] };

type Props = {
  searchParams: SloveniaCompetitionResultFilterPageRequest;
  form: FormInstance<SloveniaCompetitionResultFilterPageRequest & ExtendedFilter>;
  onFilterSubmit: (filter: SloveniaCompetitionResultFilterPageRequest) => void;
};

export const SloveniaCompetitionFilterForm = ({ searchParams, form, onFilterSubmit }: Props) => {
  const { t } = useTranslation();

  useEffect(() => {
    form.setFieldsValue({
      ...searchParams,
      completedEducationDateRange:
        searchParams.completedEducationDateMin && searchParams.completedEducationDateMax
          ? [searchParams.completedEducationDateMin, searchParams.completedEducationDateMax]
          : undefined,
      completedAcademyDateRange:
        searchParams.completedAcademyDateMin && searchParams.completedAcademyDateMax
          ? [searchParams.completedAcademyDateMin, searchParams.completedAcademyDateMax]
          : undefined,
    });
  }, [searchParams]);

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={({ completedEducationDateRange, completedAcademyDateRange, ...filter }) =>
        onFilterSubmit({ ...filter, pageIndex: undefined })
      }
      name="sloveniaCompetitionFilterForm"
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(3, 1fr) `,
          gap: rowGutter,
          alignItems: "end",
        }}
        className="min-width-0-children"
      >
        <AgentCommonFilterFields />
      </div>

      <Flex justify="space-between">
        <AgentExtendedFilterModalForm
          onSubmit={(values) => {
            form.setFieldsValue(values);
            onFilterSubmit({ ...form.getFieldsValue(), pageIndex: undefined });
          }}
        />

        <Button type="primary" htmlType="submit" icon={<AntIcon type="search" />}>
          {t("common.filter")}
        </Button>
      </Flex>
    </Form>
  );
};
